import {computed, defineComponent, onMounted, reactive, ref, watch} from '@vue/composition-api';
import SystemModals, {ModalIconType} from '@/components/system-modals/system-modals.vue';
import PromotionPopup from "@/components/promotion-popup/promotion-popup.vue";
import NavbarBox from "@/components/navbar-box/navbar-box.vue";
import {
    getExternalAuthenticationContext,
    logout,
    onLogOut
} from './functions/authentication-functions';
import {
    onForceLoggedOut,
    onPaymentRequiredBlock,
    onRequestsEnded,
    onRequestsStarted
} from "@/functions/axios-functions";
import {lockWallpaper, randomizeWallpaper, unlockWallpaper, useWallpaperState} from '@/states/wallpaper-state';
import {PageContext} from "@/components/navbar-box/page-context";
import * as ImBox from "@/utilities/imbox";
import {alertDialogue} from "@/functions/system-modal-functions";
import { i18n } from './utilities/vue-i18n';

export default defineComponent({

    components: {

        SystemModals,

        NavbarBox,

        PromotionPopup,
    },

    setup(_, context) {

        ImBox.init(context).then();

        const page = ref();

        watch(() => (page.value as PageContext)?.controls, () => {

            if((page.value as PageContext).controls) {

                document.body.classList.add('with-long-header');
            }
            else
            {
                document.body.classList.remove('with-long-header');
            }
        });

        const model = reactive({blockScreen: false});

        onRequestsStarted(() => model.blockScreen = true);

        onRequestsEnded(() => model.blockScreen = false);

        context.root.$router.afterEach(async () => {

            window.scrollTo(0, 0);
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function handleServiceWorkerMessage(event: any) {

            if (event.data && event.data.type === 'appVersionChanged') {
                alertDialogue(
                    i18n.t('app-version.new-version-available') as string, 
                    i18n.t('app-version.reload-to-update-meesage') as string, 
                    ModalIconType.warning
                ).then(() => location.reload());
            }

        }

        onMounted(async () => {

            navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage as EventListener);
        });

        onLogOut(() => {

            getExternalAuthenticationContext().disableGoogleLoginAutoSelect();

            setTimeout(() => {

                if (context.root.$route.meta.anonymous !== true) {

                    context.root.$router.push({name: 'Sign In', query: {redirect: context.root.$route.fullPath}});
                }

            }, 1000);
        });

        onForceLoggedOut(() => logout());

        onPaymentRequiredBlock(async () => await alertDialogue(i18n.t('general.account-blocked') as string, i18n.t('general.account-blocked-message') as string, ModalIconType.warning));

        const wallpaperState = useWallpaperState();

        const wallpaperLocked = computed(() => wallpaperState == null || wallpaperState.lockedWallpaper !== '');

        const toggleWallpaperLock = () => wallpaperLocked.value ? unlockWallpaper(wallpaperState) : lockWallpaper(wallpaperState);

        const states = { wallpapersState: useWallpaperState() };

        return {

            model,

            logout: () => logout(),

            randomizeWallpaper: () => randomizeWallpaper(wallpaperState),

            wallpaperLocked,

            toggleWallpaperLock,

            page,

            states,

            appVersion: process.env.APP_VERSION
        };
    }
});
